import { render, staticRenderFns } from "./DataTableColumnActions.vue?vue&type=template&id=1f28d5a9&"
import script from "./DataTableColumnActions.vue?vue&type=script&lang=js&"
export * from "./DataTableColumnActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports